/* === ACCESORII CUSTOM: AJAX ADD TO CART START === */

document.addEventListener("DOMContentLoaded", function () {
  const forms = document.querySelectorAll('.collection-buy-form');

  function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const count = cart.item_count;
      const total = (cart.total_price / 100).toFixed(2);

      const cartLinks = document.querySelectorAll('a[href="/cart"], a[href$="/cart"]');

      cartLinks.forEach(link => {
        link.textContent = `${count} Cos ${total} lei`;
      });
    })
    .catch(err => {
      console.error('Cart count update error:', err);
    });
}

  forms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(res => res.json())
        .then(() => {
          const button = form.querySelector('.collection-atc-button[type="submit"]');
          if (button) {
            const originalText = button.innerText;

            button.innerText = 'Adaugat ✓';
            button.disabled = true;

            setTimeout(() => {
              button.innerText = originalText;
              button.disabled = false;
            }, 1500);
          }

          updateCartCount();
        })
        .catch(err => {
          console.error('Add to cart error:', err);
        });
    });
  });
});

/* === ACCESORII CUSTOM: AJAX ADD TO CART END === */